import dayjs from "dayjs"
import baseAxios from "../../../../services/baseAxios"
import { EnumEndpoints } from "@/constants/app/type"
import { parseJson } from "@/utils/safeParse/parseJson"
import { EnumAPIKey } from "@/constants/app/api"

export const getToursCategoriesService = async (params: any) => {
  const cachedToursCategories = localStorage.getItem(`tours_categories`)
  const now = dayjs()
  let cacheTime = dayjs(parseFloat(localStorage.getItem(`toursCategoriesCachedTime`) || '0'))
  
  const isExpired = cacheTime.diff(now, 'minute') <= 60
  
  let res: any
  if (!!cachedToursCategories && !isExpired) {
    res = parseJson(cachedToursCategories) || {
      departures: [],
      destinations: [],
      tourCategories: []
    }
  } else {
    localStorage.setItem(`toursCategoriesCachedTime`, `${now.add(12, 'hour').valueOf()}`)

    res = await baseAxios(EnumAPIKey.API_TOUR).get(EnumEndpoints.TOURS_CATEGORIES, {
      params
    })

    if (!!res && typeof res === 'object') {
      localStorage.setItem(`tours_categories`, JSON.stringify(res))
    }
  }
  return res
}